/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  function initAddToCartReveal() {
    var buttonSelector = [
      '.nearkii-product-page .product-form__add-button',
      '.nearkii-cart-page .cart-recap__checkout',
      '.mini-cart__button-container .button--primary'
    ].join(', ');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    function shakeButton(button) {
      button.classList.remove('nearkii-add-button--reveal');
      void button.offsetWidth;
      button.classList.add('nearkii-add-button--reveal');
    }

    document.addEventListener('mouseover', function (event) {
      var button = event.target.closest(buttonSelector);

      if (!button || (event.relatedTarget && button.contains(event.relatedTarget))) {
        return;
      }

      shakeButton(button);
    });

    document.addEventListener('animationend', function (event) {
      if (event.target.matches(buttonSelector)) {
        event.target.classList.remove('nearkii-add-button--reveal');
      }
    });

    var revealObserver;
    var scrollCheckQueued = false;

    function revealButton(button) {
      if (button.getAttribute('data-nearkii-scroll-revealed') === 'true') {
        return;
      }

      button.setAttribute('data-nearkii-scroll-revealed', 'true');
      shakeButton(button);
    }

    function observeButtons(root) {
      var scope = root && root.querySelectorAll ? root : document;

      scope.querySelectorAll(buttonSelector).forEach(function (button) {
        if (revealObserver) {
          revealObserver.observe(button);
        }
      });
    }

    function checkButtonsAfterScroll() {
      if (scrollCheckQueued) {
        return;
      }

      scrollCheckQueued = true;

      window.requestAnimationFrame(function () {
        scrollCheckQueued = false;

        document.querySelectorAll(buttonSelector).forEach(function (button) {
          var rect;

          rect = button.getBoundingClientRect();

          if (rect.top <= window.innerHeight * 0.88 && rect.bottom >= 0) {
            revealButton(button);
          }
        });
      });
    }

    if ('IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          revealButton(entry.target);
          revealObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -12% 0px'
      });

      observeButtons(document);
      document.addEventListener('shopify:section:load', function (event) {
        observeButtons(event.target);
      });
    } else {
      window.addEventListener('scroll', checkButtonsAfterScroll, { passive: true });
      window.addEventListener('resize', checkButtonsAfterScroll);
      checkButtonsAfterScroll();
    }
  }

  function initMobileBuyBarEffect() {
    var buyBars = document.querySelectorAll('.nearkii-product-buy-bar');
    var mobileQuery = window.matchMedia('(max-width: 640px)');

    if (!buyBars.length || !mobileQuery.matches) {
      return;
    }

    function revealBuyBar(buyBar) {
      buyBar.classList.add('nearkii-product-buy-bar--mobile-visible');
    }

    if (!window.IntersectionObserver) {
      buyBars.forEach(revealBuyBar);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        revealBuyBar(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.45
    });

    buyBars.forEach(function (buyBar) {
      observer.observe(buyBar);
    });
  }

  function initHomepageSavedProducts() {
    var storageKey = 'nearkii-saved-products';
    var savedProducts = [];
    var wishlistPage = document.querySelector('[data-nearkii-wishlist-page]');
    var wishlistRenderId = 0;

    function readSavedProducts() {
      var storedProducts = [];

      try {
        storedProducts = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      } catch (error) {
        storedProducts = [];
      }

      if (!Array.isArray(storedProducts)) {
        return [];
      }

      return storedProducts.filter(function (handle, index) {
        return typeof handle === 'string' && handle.length > 0 && storedProducts.indexOf(handle) === index;
      });
    }

    function updateButton(button) {
      var isSaved = savedProducts.indexOf(button.getAttribute('data-nearkii-save-product')) !== -1;

      button.classList.toggle('is-saved', isSaved);
      button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      button.setAttribute('aria-label', isSaved ? 'Remove from wish list' : 'Save to wish list');
    }

    function animateHeart(button) {
      var headerWishlist = document.querySelector('.nearkii-header-wishlist');

      [button, headerWishlist].forEach(function (element) {
        if (!element) {
          return;
        }

        element.classList.remove('nearkii-heart-pop');
        void element.offsetWidth;
        element.classList.add('nearkii-heart-pop');

        window.setTimeout(function () {
          element.classList.remove('nearkii-heart-pop');
        }, 380);
      });
    }

    function updateInterface() {
      document.querySelectorAll('[data-nearkii-save-product]').forEach(updateButton);
      document.querySelectorAll('[data-nearkii-wishlist-count]').forEach(function (count) {
        count.textContent = savedProducts.length;
        count.hidden = savedProducts.length === 0;
      });
    }

    function createWishlistCard(product, handle) {
      var card = document.createElement('article');
      var media = document.createElement('a');
      var image = document.createElement('img');
      var saveButton = document.createElement('button');
      var body = document.createElement('div');
      var titleLink = document.createElement('a');
      var title = document.createElement('h2');
      var price = document.createElement('p');
      var action = document.createElement('a');
      var productUrl = '/products/' + encodeURIComponent(handle);
      var imageUrl = product.featured_image || (product.images && product.images[0]) || '';
      var formattedPrice;

      card.className = 'nearkii-wishlist-card';

      media.className = 'nearkii-wishlist-card__media';
      media.href = productUrl;
      image.src = imageUrl;
      image.alt = product.title || '';
      image.loading = 'lazy';
      media.appendChild(image);

      saveButton.type = 'button';
      saveButton.className = 'nearkii-wishlist-card__save is-saved';
      saveButton.setAttribute('data-nearkii-save-product', handle);
      saveButton.setAttribute('aria-label', 'Remove ' + (product.title || 'product') + ' from wish list');
      saveButton.setAttribute('aria-pressed', 'true');
      saveButton.innerHTML = '<svg focusable="false" class="icon icon--heart" viewBox="0 0 17 15" aria-hidden="true"><path d="M15.0349331 1.40485867C14.1287273.49933787 12.9252477 0 11.6443673 0S9.16000731.49933787 8.25448651 1.40417371c-.01164437.01164436-.02328874.02328873-.03493311.03561806-.01164436-.01232933-.02260377-.02328873-.03424813-.0349331C7.2790995.49933787 6.07561989 0 4.79473949 0 3.51385908 0 2.31037947.49933787 1.40417371 1.40485867.49796794 2.31037947 0 3.51385908 0 4.79473949 0 6.07561989.4986529 7.2790995 1.40417371 8.1846203L8.2195534 15l6.8153797-6.8153797c.9055208-.9055208 1.4041737-2.10900041 1.4041737-3.38988081 0-1.28019545-.4986529-2.48436002-1.4041737-3.38988082z"></path></svg>';

      body.className = 'nearkii-wishlist-card__body';
      titleLink.href = productUrl;
      title.className = 'nearkii-wishlist-card__title';
      title.textContent = product.title || 'Product';
      titleLink.appendChild(title);

      if (window.Currency && window.theme && window.theme.moneyFormat) {
        formattedPrice = window.Currency.formatMoney(product.price, window.theme.moneyFormat);
      } else {
        formattedPrice = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format((Number(product.price) || 0) / 100);
      }

      price.className = 'nearkii-wishlist-card__price';
      price.textContent = formattedPrice;

      action.className = 'nearkii-wishlist-card__action';
      action.href = productUrl;
      action.innerHTML = '<svg focusable="false" class="icon icon--cart" viewBox="0 0 27 24" aria-hidden="true"><g transform="translate(0 1)" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd"><circle stroke-linecap="square" cx="11" cy="20" r="2"></circle><circle stroke-linecap="square" cx="22" cy="20" r="2"></circle><path d="M7.31 5h18.27l-1.44 10H9.78L6.22 0H0"></path></g></svg><span>ADD TO CART</span>';

      body.appendChild(titleLink);
      body.appendChild(price);
      body.appendChild(action);
      card.appendChild(media);
      card.appendChild(saveButton);
      card.appendChild(body);

      return card;
    }

    function renderWishlistPage() {
      var grid;
      var status;
      var empty;
      var renderId = ++wishlistRenderId;
      var productsToRender = savedProducts.slice();

      if (!wishlistPage) {
        return;
      }

      grid = wishlistPage.querySelector('[data-nearkii-wishlist-grid]');
      status = wishlistPage.querySelector('[data-nearkii-wishlist-status]');
      empty = wishlistPage.querySelector('[data-nearkii-wishlist-empty]');

      if (!grid || !status || !empty) {
        return;
      }

      grid.innerHTML = '';

      if (productsToRender.length === 0) {
        status.hidden = true;
        empty.hidden = false;
        return;
      }

      status.hidden = false;
      status.textContent = 'Loading your saved products…';
      empty.hidden = true;

      Promise.all(productsToRender.map(function (handle) {
        return window.fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin'
        }).then(function (response) {
          if (!response.ok) {
            throw new Error('Product unavailable');
          }

          return response.json();
        }).then(function (product) {
          return createWishlistCard(product, handle);
        }).catch(function () {
          return null;
        });
      })).then(function (cards) {
        var availableCards = cards.filter(Boolean);

        if (renderId !== wishlistRenderId) {
          return;
        }

        grid.innerHTML = '';
        availableCards.forEach(function (card) {
          grid.appendChild(card);
        });

        status.hidden = true;
        empty.hidden = availableCards.length > 0;
        updateInterface();
      });
    }

    savedProducts = readSavedProducts();
    updateInterface();
    renderWishlistPage();

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-nearkii-save-product]');
      var productHandle;
      var savedIndex;

      if (!button) {
        return;
      }

      productHandle = button.getAttribute('data-nearkii-save-product');

      if (!productHandle) {
        return;
      }

      savedIndex = savedProducts.indexOf(productHandle);

      if (savedIndex === -1) {
        savedProducts.push(productHandle);
      } else {
        savedProducts.splice(savedIndex, 1);
      }

      try {
        window.localStorage.setItem(storageKey, JSON.stringify(savedProducts));
      } catch (error) {
        // The visual state still works when browser storage is unavailable.
      }

      updateInterface();
      animateHeart(button);

      if (wishlistPage) {
        window.setTimeout(renderWishlistPage, 260);
      }
    });

    window.addEventListener('storage', function (event) {
      if (event.key !== storageKey) {
        return;
      }

      savedProducts = readSavedProducts();
      updateInterface();
      renderWishlistPage();
    });

    document.addEventListener('shopify:section:load', function () {
      wishlistPage = document.querySelector('[data-nearkii-wishlist-page]');
      updateInterface();
      renderWishlistPage();
    });
  }

  function initMobileHeaderOverlayState() {
    var headerSection = document.getElementById('shopify-section-header');
    var observer;

    if (!headerSection || !window.MutationObserver) {
      return;
    }

    function syncOverlayState() {
      var openOverlay = headerSection.querySelector(
        '.mobile-menu[aria-hidden="false"], #mini-cart[aria-hidden="false"]'
      );

      document.documentElement.classList.toggle(
        'nearkii-mobile-header-overlay-open',
        Boolean(openOverlay)
      );
    }

    observer = new MutationObserver(syncOverlayState);
    observer.observe(headerSection, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      childList: true,
      subtree: true
    });

    syncOverlayState();
  }

  function initBundleQuantitySync() {
    var optionSelector = '.nearkii-product-page .ast-vd-option';
    var productPage = document.querySelector('.nearkii-product-page');
    var syncQueued = false;

    if (!productPage) {
      return;
    }

    function getBundleQuantity(option) {
      var title = option.querySelector('.ast-vd-option-title');
      var match = (title ? title.textContent : option.textContent).match(/\bbuy\s+(\d+)\b/i);

      return match ? parseInt(match[1], 10) : 0;
    }

    function getQuantityInput(option) {
      var form = option.closest('form');

      return form ? form.querySelector('.nearkii-product-buy-bar [name="quantity"], .quantity-selector--product [name="quantity"]') : null;
    }

    function setQuantityFromBundle(option) {
      var quantity = getBundleQuantity(option);
      var input = getQuantityInput(option);

      if (!quantity || !input || parseInt(input.value, 10) === quantity) {
        return;
      }

      if (input.tagName === 'SELECT' && !input.querySelector('option[value="' + quantity + '"]')) {
        input.add(new Option(String(quantity), String(quantity)));
      }

      input.value = String(quantity);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function isSelected(option) {
      return option.getAttribute('aria-checked') === 'true' ||
        option.classList.contains('ast-radio-card--checked') ||
        option.classList.contains('ast-vd-option-active');
    }

    function syncSelectedBundles() {
      productPage.querySelectorAll('.ast-vd-option').forEach(function (option) {
        if (isSelected(option)) {
          setQuantityFromBundle(option);
        }
      });
    }

    function queueSelectedBundleSync() {
      if (syncQueued) {
        return;
      }

      syncQueued = true;
      window.requestAnimationFrame(function () {
        syncQueued = false;
        syncSelectedBundles();
      });
    }

    productPage.addEventListener('click', function (event) {
      var option = event.target.closest(optionSelector);

      if (!option) {
        return;
      }

      window.setTimeout(function () {
        setQuantityFromBundle(option);
      }, 0);
    });

    if (window.MutationObserver) {
      new MutationObserver(queueSelectedBundleSync).observe(productPage, {
        attributes: true,
        attributeFilter: ['aria-checked', 'class'],
        childList: true,
        subtree: true
      });
    }

    syncSelectedBundles();
  }

  function initProductQuantityState() {
    var selector = '.nearkii-product-page .quantity-selector--product';

    function syncQuantityState(quantitySelector) {
      var input = quantitySelector.querySelector('[name="quantity"]');
      var decreaseButton = quantitySelector.querySelector('[data-action="decrease-picker-quantity"]');
      var value = input ? parseInt(input.value, 10) : 1;

      if (!input || !decreaseButton) {
        return;
      }

      decreaseButton.disabled = !isFinite(value) || value <= 1;
      decreaseButton.setAttribute('aria-disabled', String(decreaseButton.disabled));
    }

    function syncAllQuantityStates() {
      document.querySelectorAll(selector).forEach(syncQuantityState);
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest(selector + ' .quantity-selector__button');

      if (button) {
        syncQuantityState(button.closest(selector));
      }
    });

    document.addEventListener('input', function (event) {
      var quantitySelector = event.target.closest(selector);

      if (quantitySelector && event.target.matches('[name="quantity"]')) {
        syncQuantityState(quantitySelector);
      }
    });

    document.addEventListener('change', function (event) {
      var quantitySelector = event.target.closest(selector);

      if (quantitySelector && event.target.matches('[name="quantity"]')) {
        syncQuantityState(quantitySelector);
      }
    });

    syncAllQuantityStates();
  }

  function initHeaderSearchDismiss() {
    if (document.documentElement.dataset.nearkiiSearchDismissReady === 'true') {
      return;
    }

    document.documentElement.dataset.nearkiiSearchDismissReady = 'true';

    function closeSearch(searchBar) {
      if (!searchBar) {
        return;
      }

      var wrapper = searchBar.closest('.header__search-bar-wrapper');
      var header = searchBar.closest('.header');
      var input = searchBar.querySelector('.search-bar__input');
      var results = searchBar.querySelector('.search-bar__results');
      var menu = searchBar.querySelector('.search-bar__menu-wrapper');
      var toggle = header && header.querySelector('[data-action="toggle-search"]');

      if (results) {
        results.setAttribute('aria-hidden', 'true');
      }

      if (menu) {
        menu.setAttribute('aria-hidden', 'true');
      }

      searchBar.classList.remove('is-expanded', 'is-loading');

      if (input) {
        input.classList.remove('is-filled');
        input.blur();
      }

      if (wrapper) {
        wrapper.classList.remove('is-fixed', 'is-visible');
      }

      if (header) {
        header.classList.remove('header--search-expanded');
      }

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }

      document.body.classList.remove('no-mobile-scroll');
    }

    function closeAllSearchBars() {
      document.querySelectorAll('.header .search-bar').forEach(closeSearch);
    }

    function keepPredictiveSearchClosed(event) {
      if (!event.target.matches('.header .search-bar__input')) {
        return;
      }

      var searchBar = event.target.closest('.search-bar');
      var results = searchBar && searchBar.querySelector('.search-bar__results');
      var menu = searchBar && searchBar.querySelector('.search-bar__menu-wrapper');

      if (results) {
        results.setAttribute('aria-hidden', 'true');
      }

      if (menu) {
        menu.setAttribute('aria-hidden', 'true');
      }

      if (searchBar) {
        searchBar.classList.remove('is-expanded', 'is-loading');
      }

      event.stopPropagation();
    }

    document.addEventListener('focusin', keepPredictiveSearchClosed, true);
    document.addEventListener('input', keepPredictiveSearchClosed, true);

    document.addEventListener('submit', function (event) {
      if (event.target.matches('.header .search-bar')) {
        closeSearch(event.target);
      }
    }, true);

    document.addEventListener('click', function (event) {
      var resultAction = event.target.closest(
        '.header .search-bar__result-item, .header .search-bar__result-link, .header .search-bar__view-all, .header .search-bar__menu-link'
      );

      if (resultAction) {
        closeSearch(resultAction.closest('.search-bar'));
      }
    }, true);

    document.addEventListener('pointerdown', function (event) {
      document.querySelectorAll('.header .search-bar.is-expanded').forEach(function (searchBar) {
        if (!searchBar.contains(event.target)) {
          closeSearch(searchBar);
        }
      });
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && event.target.matches('.header .search-bar__input')) {
        event.stopPropagation();
        return;
      }

      if (event.key !== 'Escape') {
        return;
      }

      var activeSearch = document.querySelector('.header .search-bar.is-expanded');

      if (activeSearch) {
        event.preventDefault();
        closeSearch(activeSearch);
      }
    }, true);

    window.addEventListener('pageshow', closeAllSearchBars);
  }

  function initNearkiiPersonalization() {
    document.querySelectorAll('[data-nearkii-personalization]').forEach(function (personalization) {
      var toggle = personalization.querySelector('[data-nearkii-personalization-toggle]');
      var fields = personalization.querySelector('[data-nearkii-personalization-fields]');

      if (!toggle || !fields || personalization.dataset.nearkiiPersonalizationReady === 'true') {
        return;
      }

      personalization.dataset.nearkiiPersonalizationReady = 'true';

      var personalizationFile = personalization.querySelector('[data-nearkii-personalization-file]');
      var personalizationFileName = personalization.querySelector('[data-nearkii-file-name]');

      function syncPersonalizationFileName() {
        if (!personalizationFile || !personalizationFileName) {
          return;
        }

        personalizationFileName.textContent = personalizationFile.files && personalizationFile.files.length
          ? personalizationFile.files[0].name
          : 'No file selected';
      }

      function syncPersonalizationState() {
        var isEnabled = toggle.checked;

        personalization.classList.toggle('nearkii-personalization--active', isEnabled);
        toggle.setAttribute('aria-expanded', String(isEnabled));
        fields.hidden = !isEnabled;
        fields.setAttribute('aria-hidden', String(!isEnabled));
        fields.querySelectorAll('input, select, textarea').forEach(function (field) {
          field.disabled = !isEnabled;
        });
      }

      toggle.addEventListener('change', syncPersonalizationState);
      if (personalizationFile) {
        personalizationFile.addEventListener('change', syncPersonalizationFileName);
      }
      syncPersonalizationState();
      syncPersonalizationFileName();
    });

    if (document.documentElement.dataset.nearkiiFileUploadReady === 'true') {
      return;
    }

    document.documentElement.dataset.nearkiiFileUploadReady = 'true';

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-action="add-to-cart"]');
      var form = button ? button.closest('form[action*="/cart/add"]') : null;
      var fileInput = form ? form.querySelector('[data-nearkii-personalization-file]') : null;

      if (!button || !form || !fileInput || !fileInput.files || !fileInput.files.length || (window.theme && window.theme.cartType === 'page')) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      button.setAttribute('disabled', 'disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      var cartAddUrl = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add';

      fetch(cartAddUrl + '.js', {
        body: new FormData(form),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () {
            return {};
          }).then(function (error) {
            throw new Error(error.description || 'The personalized item could not be added to the cart.');
          });
        }

        button.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        var eventTarget = form.closest('[data-section-type="product"]') || form;
        var quantityInput = form.querySelector('[name="quantity"]');

        eventTarget.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            button: button,
            variant: null,
            quantity: quantityInput ? parseInt(quantityInput.value, 10) : 1
          }
        }));
      }).catch(function (error) {
        button.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        window.alert(error.message);
      });
    }, true);
  }

  function initNearkiiCustomFeatures() {
    initHeaderSearchDismiss();
    initAddToCartReveal();
    initMobileBuyBarEffect();
    initHomepageSavedProducts();
    initMobileHeaderOverlayState();
    initProductQuantityState();
    initBundleQuantitySync();
    initNearkiiPersonalization();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNearkiiCustomFeatures);
  } else {
    initNearkiiCustomFeatures();
  }
}());
